{#if $isUserLoggedIn}
  <TimelineHomePage/>
{:else}
  <NotLoggedInHome/>
{/if}
<script>
  import NotLoggedInHome from '../_components/NotLoggedInHome.html'
  import { store } from '../_store/store.js'
  import TimelineHomePage from '../_components/TimelineHomePage.html'
  import { observe } from 'svelte-extras'
  import { doQuickLoginIfNecessary } from '../_actions/doQuickLoginIfNecessary.js'
  import { database } from '../_database/database.js'

  export default {
    async oncreate () {
      doQuickLoginIfNecessary()
      const params = new URLSearchParams(location.search)
      if (typeof params.get('icon') === 'string') {
        await database.setIconColors(params.get('icon'))
      }
    },
    store: () => store,
    methods: {
      observe
    },
    components: {
      NotLoggedInHome,
      TimelineHomePage
    }
  }
</script>
